import React, { useState, useEffect, Fragment } from "react";

// Images
import Partner1Img from "../../assets/images/partners/partner_1.png";
import Partner2Img from "../../assets/images/partners/partner_2.png";
import Partner3Img from "../../assets/images/partners/partner_3.png";
import Partner4Img from "../../assets/images/partners/partner_4.png";

import styles from "./partner-images.module.scss";

const getPartnerImg = (i, partners) => {
  let imgSrc;

  if (i === 1) {
    imgSrc = Partner1Img.src;
  } else if (i === 2) {
    imgSrc = Partner2Img.src;
  } else if (i === 3) {
    imgSrc = Partner3Img.src;
  } else if (i === 4) {
    imgSrc = Partner4Img.src;
  } else {
    imgSrc = Partner1Img.src;
  }

  return <img className={styles[`partnerImage${partners}`]} alt={`Partner ${i}`} src={imgSrc} />;
};

const renderImages = partners =>
  [...Array(partners).keys()].map(i => <Fragment key={i}>{getPartnerImg(i + 1, partners)}</Fragment>);

function PartnerImages({ partners = 3, partnersTablet = null, partnersMobile = null }) {
  const [partnersAmount, setPartnersAmount] = useState(null);

  const updatePartnersAmount = () => {
    const getPartnersAmount = () => {
      if (window.innerWidth < 768) {
        return partnersMobile || partners;
      }
      if (window.innerWidth < 1024) {
        return partnersTablet || partners;
      }
      return partners;
    };

    setPartnersAmount(getPartnersAmount());
  };

  useEffect(() => {
    window.addEventListener("resize", updatePartnersAmount);
    updatePartnersAmount();
    return () => window.removeEventListener("resize", updatePartnersAmount);
  }, [partners, partnersTablet, partnersMobile]);

  return <div className={styles.partnerImages}>{renderImages(partnersAmount)}</div>;
}

export default PartnerImages;
